module.exports = "static/styles/images/example-app.13c07aca2951049b9748a805922507f3.png";


//////////////////
// WEBPACK FOOTER
// ./lib/help/styles/images/example-app.png
// module id = 282
// module chunks = 0